var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4470_867)","key":0},React.createElement("path",{"d":"M7.315 0.875L5.32438 4.90875L0.875 5.55187L4.095 8.69313L3.33375 13.125L7.315 11.0337L11.2962 13.125L10.535 8.69313L13.755 5.55625L9.30562 4.90875L7.315 0.875Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4470_867"},React.createElement("rect",{"width":"14","height":"14","fill":"white"})))]);
}

Star.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Star;

Star.default = Star;
